/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Loading_Subscription_DataInputs */

const en_loading_subscription_data = /** @type {(inputs: Loading_Subscription_DataInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Loading subscription data...`)
};

const fr_loading_subscription_data = /** @type {(inputs: Loading_Subscription_DataInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Chargement des données d'abonnement...`)
};

const de_loading_subscription_data = /** @type {(inputs: Loading_Subscription_DataInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Abonnementdaten werden geladen...`)
};

const it_loading_subscription_data = /** @type {(inputs: Loading_Subscription_DataInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Caricamento dati abbonamento in corso...`)
};

const ru_loading_subscription_data = /** @type {(inputs: Loading_Subscription_DataInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Загрузка данных подписки...`)
};

const es_loading_subscription_data = /** @type {(inputs: Loading_Subscription_DataInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cargando datos de suscripción...`)
};

const zh_cn2_loading_subscription_data = /** @type {(inputs: Loading_Subscription_DataInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`正在加载订阅数据……`)
};

const ja_loading_subscription_data = /** @type {(inputs: Loading_Subscription_DataInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`サブスクリプションデータを読み込んでいます...`)
};

const hi_loading_subscription_data = /** @type {(inputs: Loading_Subscription_DataInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`सदस्यता डेटा लोड हो रहा है...`)
};

const pt_pt2_loading_subscription_data = /** @type {(inputs: Loading_Subscription_DataInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Carregando dados de assinatura...`)
};

/**
* | output |
* | --- |
* | "Loading subscription data..." |
*
* @param {Loading_Subscription_DataInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const loading_subscription_data = /** @type {((inputs?: Loading_Subscription_DataInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Loading_Subscription_DataInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_loading_subscription_data(inputs)
	if (locale === "de") return de_loading_subscription_data(inputs)
	if (locale === "it") return it_loading_subscription_data(inputs)
	if (locale === "ru") return ru_loading_subscription_data(inputs)
	if (locale === "es") return es_loading_subscription_data(inputs)
	if (locale === "zh-CN") return zh_cn2_loading_subscription_data(inputs)
	if (locale === "ja") return ja_loading_subscription_data(inputs)
	if (locale === "hi") return hi_loading_subscription_data(inputs)
	if (locale === "pt-PT") return pt_pt2_loading_subscription_data(inputs)
	return en_loading_subscription_data(inputs)
});